import { FileText, Layers, Mail } from 'styled-icons/feather';
import { lighten } from 'polished';
import Link from 'next/link';
import { Grid, Column, Card, Title, Paragraph } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import { colors } from '@/themes';
import Section from '@/components/section';

const lightBlue = lighten(.05, colors.brand.primary);

const CardTitle = tw.h3`
  text-brand-primary/95
  text-3xl
  font-normal
  mb-2
`;

const CardDescription = tw(Paragraph)`
  mb-0
`;

const CardContent = tw.div`
  flex
  items-start
  p-4
`;

const Why = () => {
  return (
    <Section className="md:pb-28" angleBottomReverse backgroundColor={lightBlue}>
      <Title className="text-white lg:mt-8 lg:mb-16">What drives us</Title>
      <Grid className="gap-12" columns={[1, 1, 2]}>
        <Column>
          <Paragraph className="mb-12 text-white/80">
            Everyone should have easy access to global capital markets, without high fees and repression. We&apos;ve experienced first hand that unfortunately this is not the case everywhere.
          </Paragraph>
          <Paragraph className="mb-12 text-white/80">
            In order to pay people around the world we&apos;ve had to stitch together various services and pay absurd fees just to pay honest people for honest work. In many parts of the world obtaining a bank account or accessing their funds in a timely manner is impossible. This is excluding people from the global economy and preventing them from improving their life.
          </Paragraph>
          <Paragraph className="font-bold italic mb-12 text-white/80">
            We believe that the ability to bank and transact is a fundamental human right. Without access to capital you are entirely isolated and unable to function in today&apos;s society.
          </Paragraph>
          <Paragraph className="text-white/80">
            The blockchain and other distributed ledger technologies lower the cost to transact and streamline the payment process by providing a secure, globally agreed upon settlement layer. We believe it&apos;s this technology that is going to ensure banking and commerce becomes a human right and gives you more control over your own finances. We&apos;re building the products that allow people to leverage this technology.
          </Paragraph>
        </Column>
        <Column>
          <Grid className="gap-8" columns={1}>
            <Link href="/press">
              <Card>
                <CardContent>
                  <FileText className="mr-8 shrink-0" size={48} />
                  <div>
                    <CardTitle>Press Information</CardTitle>
                    <CardDescription>News, company info, and media resources and contact information.</CardDescription>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link href="/branding">
              <Card>
                <CardContent>
                  <Layers className="mr-8 shrink-0" size={48} />
                  <div>
                    <CardTitle>Branding and resources</CardTitle>
                    <CardDescription>Official logos, badges and buttons for your website, mobile app or print.</CardDescription>
                  </div>
                </CardContent>
              </Card>
            </Link>

            <Link href="/contact">
              <Card>
                <CardContent>
                  <Mail className="mr-8 shrink-0" size={48} />
                  <div>
                    <CardTitle>Contact us</CardTitle>
                    <CardDescription>Get in touch with our sales, support or compliance teams.</CardDescription>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        </Column>
      </Grid>
    </Section>
  );
};

export default Why;
